import { SimpleGrid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { Field, Form } from "react-final-form";
import { AuthContext } from "../../../../context/AuthContext";
import { ROLES_OPTION } from "../../../../utils/constants";
import AutoPlacesField from "../../../fields/AutoPlacesField";
import FileUploadField from "../../../fields/FileUploadField";
import InputField from "../../../fields/InputField";
import PlacesField from "../../../fields/PlacesField";
import SelectBarangayField from "../../../fields/SelectBarangayField";
import SelectCityField from "../../../fields/SelectCityField";
import SelectField from "../../../fields/SelectField";
import SelectProvincesField from "../../../fields/SelectProvincesField";
import { updateValidator as validate } from "./validators";

type CreateUpdateFormProps = {
  onSubmit: (...params: any) => void;
  formName?: string;
  initialValues?: any;
  disabledFields?: string[];
};

const UserUpdateForm = (props: CreateUpdateFormProps) => {
  const { auth } = useContext(AuthContext);
  const { onSubmit, formName, initialValues, disabledFields } = props;

  const [city, setCity] = useState(initialValues?.address_city || "");
  const isAdmin = auth.role === "ADMIN";

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      mutators={{
        setFile: ([args], state, { changeValue }) => {
          changeValue(state, "file", () => args);
        },
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} id={formName}>
          <SimpleGrid columns={[1, 2]} spacing={5} p="10">
            <Field name="name" label="Name" component={InputField} />
            <Field name="username" label="Username" component={InputField} />
            <Field name="password" label="Password" component={InputField} />

            {isAdmin && (
              <>
                <Field
                  name={`role`}
                  label="Role"
                  component={SelectField}
                  options={ROLES_OPTION}
                  menuPortalTarget={document.body}
                />
              </>
            )}

            <Field
              name="phone"
              label="Phone"
              type="tel"
              component={InputField}
            />

            <Field
              name="email"
              label="Email"
              type="email"
              component={InputField}
            />

            <Field
              name={`status`}
              label="Status"
              component={SelectField}
              options={[
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
                { label: "Under Review", value: "review" },
              ]}
              menuPortalTarget={document.body}
              isDisabled={disabledFields?.includes("status")}
            />
          </SimpleGrid>
          <SimpleGrid columns={[1]} spacing={5} p="10">
            <Field
              name={`address_city`}
              label="City / Municipality"
              component={SelectCityField}
              province_code="1667"
              menuPortalTarget={document.body}
              onChange={(e: any) => setCity(e)}
            />
            <Field
              name={`address_brgy`}
              label="Baranggay"
              component={SelectBarangayField}
              menuPortalTarget={document.body}
              city_code={city}
            />
            <Field
              name={`address_details`}
              label="Other Details"
              component={InputField}
              placeholder="(Purok, Street, Landmarks)"
            />
          </SimpleGrid>
          {/* {!disabledFields?.includes("location") && (
            <SimpleGrid columns={[1]} spacing={5} px="10" py="5">
              <Field name="location" component={PlacesField} />
            </SimpleGrid>
          )} */}

          {/* <SimpleGrid columns={[1]} spacing={5} px="10" py="5">
            <FileUploadField
              isUpdate={true}
              img={initialValues.imageURL}
              setFile={props.form.mutators.setFile}
            />
            {isAdmin && <Field name="location" component={PlacesField} />}
          </SimpleGrid> */}
        </form>
      )}
    </Form>
  );
};

export default UserUpdateForm;
